import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";
import { LOGO_MARK, TAGLINE } from "../lib/brand";
import { LogoMark } from "../components/Logo";

export default function Verify() {
  const { memberId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/athlete-id/verify/${memberId}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(formatApiError(e)));
  }, [memberId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-2 mb-6" data-testid="logo-link">
          <LogoMark src={LOGO_MARK} size="w-14 h-14" />
          <span className="brand-text text-2xl">NORDGAMING</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">{TAGLINE}</span>
        </Link>
        <div className="card-solid p-8 text-center tracing-border" data-testid="verify-page">
          {error ? (
            <>
              <XCircle className="w-10 h-10 text-red-400 mx-auto" />
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-red-400 mt-4">Ungültig</div>
              <div className="text-white/70 text-sm mt-2">{error}</div>
            </>
          ) : !data ? (
            <div className="font-mono text-xs text-white/40 uppercase tracking-[0.2em]">Prüfe…</div>
          ) : (
            <>
              {data.valid ? (
                <CheckCircle2 className="w-10 h-10 text-accent mx-auto" />
              ) : (
                <XCircle className="w-10 h-10 text-red-400 mx-auto" />
              )}
              <div className={`font-mono text-[10px] uppercase tracking-[0.3em] mt-4 ${data.valid ? "text-accent" : "text-red-400"}`}>
                {data.valid ? "Verifiziert" : "Abgelaufen"}
              </div>
              <div className="font-display text-2xl mt-3 tracking-tight">{data.name}</div>
              <div className="font-mono text-primary text-sm mt-1 tabular-nums tracking-wider">{data.member_id}</div>
              <div className="text-white/60 text-sm mt-4">{data.club}</div>
              {data.valid_until && (
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mt-2">
                  Gültig bis {new Date(data.valid_until).toLocaleDateString("de-DE")}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
